import { render, staticRenderFns } from "./BuildingCard.vue?vue&type=template&id=7f7356a8"
import script from "./BuildingCard.vue?vue&type=script&lang=js"
export * from "./BuildingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports